import Landing from "../components/Landing";
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import Funds from '../components/Funds';
import PageHeader from "../components/PageHeader";
import poster from "../assets/posterngo.png";
import speaker from "../assets/Initiatives/speaker.jpeg";

import '../css/about.css';
import Client from "../components/Client";

export default function About() {
    return (
        <>
            <Navbar />
            <PageHeader title="About Us" path="/about" name="About Us" />
          

              <div className="donations">
                {/* <h2 className='logs' style={{backgroundColor:recentLogin?'whitesmoke':'transparent'}}>{recentLogin.length>0?`Last Login: ${recentLogin}`:<span>&#8203;</span>}</h2> */}
                <div className="container">
                    <div className="donate">
                        <div className="row align-items-center">
                            <div className="col-lg-7">
                                <div className="donate-content">
                                    <div className="section-header">
                                        <p>Our Motto</p>
                                        <h2>“नर सेवा, नारायण सेवा"</h2>
                                    </div>
                                    <div className="donate-text">
                                        <p>
                                            शिक्षा, महिला सशक्तिकरण, और सतत विकास के माध्यम से वंचित समुदायों को आगे बढ़ाने तथा विशेष 
                        रूप से महिला प्रशिक्षण, बच्चों में कुपोषण को समाप्त करने के हमारे मिशन में सहयोग दें।
                                            </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="donate-form">

                                    
    {/* <h4>Poster</h4> */}
    <img 
        src={poster} 
        alt="Poster"
        className="img-fluid donation-qr"
    />
    {/* <p className="mt-2">Pictorial Representation of Our Aim</p> */}



                                    {/* <form onSubmit={handleSubmit}>
                                        <div className="control-group">
                                            <input onChange={(e) => setName(e.target.value)} id='name' type="text" className="form-control" placeholder="Name" required autoComplete='name' />
                                        </div>
                                        <div className="control-group">
                                            <input onChange={(e) => setEmail(e.target.value)} value={email} id='email' type="email" className="form-control" placeholder="Email" disabled={showLogin} required autoComplete='email' />
                                        </div>
                                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                            <input type="radio" className="btn-check" name="btnradio" id="btnradio1" defaultChecked onChange={() => setAmount(100)} />
                                            <label htmlFor='btnradio1' className="btn btn-custom btn-outline-warning"><i className='fa fa-indian-rupee' /> 100</label>

                                            <input type="radio" className="btn-check" name="btnradio" id="btnradio2" onChange={() => setAmount(500)} />
                                            <label htmlFor='btnradio2' className="btn btn-custom btn-outline-warning"><i className='fa fa-indian-rupee' /> 500</label>

                                            <input type="radio" className="btn-check" name="btnradio" id="btnradio3" onChange={() => setAmount(1)} />
                                            <label htmlFor='btnradio3' className="btn btn-custom btn-outline-warning"><i className='fa fa-indian-rupee' /> 1000</label>
                                        </div>
                                        <div>
                                            <button className="btn btn-custom" type="submit" style={{ borderRadius: "12px" }}>Donate Now</button>
                                        </div>
                                    </form> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

{/* Speaker Message Section */}
<div className="speaker-section py-5">
    <div className="container">
        <div className="row align-items-center">
            
            <div className="col-lg-4 text-center">
                <img 
                    src={speaker}
                    alt="Speaker"
                    className="img-fluid rounded shadow speaker-img"
                />
            </div>

            <div className="col-lg-8">
                <div className="speaker-content">
                    <h2 className="mb-3">Chairman's Message</h2>
                    {/* <p>
                        प्रिय साथियों,
                    </p> */}
                    <p>
                        हमारी संस्था “उड़ान फाउंडेशन” का उद्देश्य शिक्षा, महिला सशक्तिकरण, 
                        ग्राम विकास, पर्यावरण संरक्षण एवं जनकल्याण के क्षेत्रों में कार्य करते हुए विशेष 
                        रूप से महिला प्रशिक्षण, बच्चों में कुपोषण को कम करने पर ध्यान देते हैं, ताकि वंचित एवं असहाय वर्गों को आत्मनिर्भर बनाया जा सके।
                        समाज के वंचित वर्गों को शिक्षा, 
                        स्वास्थ्य और सशक्तिकरण के माध्यम से आगे बढ़ाना है। हम मानते हैं कि 
                        प्रत्येक व्यक्ति को समान अवसर मिलना चाहिए।
                    </p>
                    <p>
                        आप सभी का सहयोग और विश्वास ही हमारी सबसे बड़ी ताकत है। 
                        आइए मिलकर समाज में सकारात्मक बदलाव लाएँ।
                    </p>
                    <p className="fw-bold mt-3">
                        — Meenu Chaubey 
                        (Chairman Udaan Sewa Trust)
                    </p>
                </div>
            </div>

            {/* NGO Information Section */}
<div className="ngo-info py-5">
    <div className="container">
        <div className="section-header text-center mb-5">
            <p>About Our Organization</p>
            <h2>Udaan Sewa Trust</h2>
        </div>
        <p className="text-center">
           Established in 2019 by a group of dedicated educationists, social activists, and professionals committed to building a healthy and prosperous nation. Registered under the Indian Trust Act, 1882 (Government of Uttar Pradesh), the Trust is also certified under 12AA & 80G of the Income Tax Act, CSR-1 (Ministry of Corporate Affairs, Government of India), and NGO Darpan.

The Trust works for the upliftment of marginalized and underprivileged communities, especially women, children, SC, ST, OBC, minorities, elderly persons, differently-abled individuals, and neglected sections of society. Through community participation and an integrated development approach, UDAAN SEWA TRUST promotes education, health, women empowerment, livelihood development, environmental protection, and reduction of malnutrition among children below six years of age, striving to create a self-reliant and equitable society.
        </p>
    </div>
</div>


{/* Mission & Vision Section */}
<div className="mission-vision py-5">
    <div className="container">
        <div className="row">

            <div className="col-lg-6 mb-4">
                <div className="mv-card">
                    <h2>Our Mission</h2>
                    <p>
                        To empower women, marginalized communities by providing access to 
                        skill training, quality education, healthcare support, 
                        and women empowerment initiatives. We strive to create 
                        sustainable impact through collective efforts and reduce malnutrition among children. 
                    
                    </p>
                </div>
            </div>

            <div className="col-lg-6 mb-4">
                <div className="mv-card">
                    <h2>Our Vision</h2>
                    <p>
                        To build a society where every individual has equal 
                        opportunities to thrive, free from poverty, malnutrition, 
                        and discrimination — fostering dignity, growth, and hope.
                    </p>
                </div>
            </div>

        </div>
    </div>
</div>



              

        </div>
    </div>
</div>

            <Landing />
            <Client/>
            <Funds />
            <Footer />
            <BackToTop />
        </>
    );
}